import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import ClaimOtp from "./ClaimOtp";
import ClaimSubmitt from "./ClaimSubmitt";
import { showToaster } from "../../toster";
import "./claim.css"

const ClaimReport = () => {
    const [error, setError] = useState(null);
    const [GetResponse, setGetResponse] = useState();
    const location = useLocation();
    const navigate = useNavigate();

    const policyClaim = location.state?.policyClaim || {}; // Default to an empty object if undefined

    useEffect(() => {
        const sendOtp = async () => {
            const COTP = { PolicyNo: policyClaim.PolicyNo || null };

            try {
                const response = await axios.post(
                    "https://crmapi.smcinsurance.com:8081/api/External/RetailCustomerOTPSent",
                    COTP,
                    {
                        headers: {
                            Token: "d41d8cd98f00b204e9800998ecf8427e",
                            "Content-Type": "application/json",
                        },
                    }
                );
                if (response.status === 200 && response.data.message === "OTP sent successfully") {
                    showToaster({
                        message: "OTP sent",
                        type: "success",
                    });
                    setGetResponse(response.data)
                } else {
                    showToaster({
                        message: "Sorry, the Policy Number did not match our records.",
                        type: "error",
                    });
                }
            } catch (error) {
                showToaster({
                    message: "An error occurred while sending the OTP. Please try again.",
                    type: "error",
                });
            }
        };

        sendOtp();
    }, [policyClaim.PolicyNo, navigate]);

    return (
        <>
            <h4>Claim Intimation</h4>
            {GetResponse &&
                <ClaimOtp MobileNo={GetResponse.mobile} EmailID={GetResponse.email} PolicyNo={policyClaim.PolicyNo} />
            }
        </>
    );
};

export default ClaimReport;
